import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Form, Formik } from 'formik';
import styled from '@emotion/styled';

import AcceptAgreementField from '../shared/AcceptAgreementField';
import AppDownloadButtons from './AppDownloadButtons';
import Button from '../../../../shared/_TBComponents/Button';
import CommonFields from '../shared/CommonFields';
import GoogleAuthSection from '../shared/GoogleAuthSection';
import RegistrationFormWrapper from '../shared/RegistrationFormWrapper';
import { RegistrationSchemaGoogle, RegistrationSchemaIdnty } from '../../../../shared/utils/registrationSchemaHelper';
import { registerUser } from '../../ducks/registrationActions';

const AlreadyHaveAccountText = styled('p')`
  color: #444444;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin: 15px 0 8px;
  text-align: center;
`;

const FormGroup = styled('div')`
  z-index: 1;

  label {
    width: 100%;
  }

  @media screen and (max-width: 425px) {
    margin-bottom: 10px;
  }
`;

const IdntyRegistrationForm = () => {
  const googleUser = useSelector((state) => state.registration.data.googleUser);
  const isRegisteringWithGoogle = useSelector(
    (state) => state.registration.data.isRegisteringWithGoogle,
  );
  const isSubmitting = useSelector((state) => state.registration.ui.isSubmitting);

  const dispatch = useDispatch();
  const { search } = useLocation();
  const programId = new URLSearchParams(search).get('programId');

  const [googleResponse, setGoogleResponse] = useState(null);
  const isMobile = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);

  const handleRegistration = (values) => {
    dispatch(registerUser({
      acceptAgreement: values.acceptAgreement,
      accountCode: process.env.IDNTY_ACCT_CODE,
      authenticationMethod: isRegisteringWithGoogle ? 'GOOGLE' : 'PASSWORD',
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      countryCode: values.phone ? values.countryCode : undefined,
      easyJoinId: process.env.IDNTY_EASY_JOIN_ID,
      emailAddress: values.emailAddress,
      firstName: values.firstName,
      gender: values.gender,
      lastName: values.lastName,
      mobileNumber: values.phone,
      ...(programId && { programId }),
      ...(isRegisteringWithGoogle && { googleToken: googleResponse?.tokenId }),
      ...(!isRegisteringWithGoogle && { password: values.password }),
      registrationType: 'EXISTING_ORGANIZATION',
    }, true));
  };

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={{
        acceptAgreement: false,
        confirmedPassword: '',
        countryCode: 'US',
        emailAddress: googleUser.email || '',
        firstName: googleUser.givenName || '',
        gender: undefined,
        lastName: googleUser.familyName || '',
        password: '',
        phone: undefined,
      }}
      onSubmit={handleRegistration}
      validationSchema={
        isRegisteringWithGoogle ? RegistrationSchemaGoogle : RegistrationSchemaIdnty
      }
    >
      {({
        errors,
        isValid,
        touched,
        handleSubmit,
        setFieldValue,
        values,
      }) => (
        <RegistrationFormWrapper
          subtitle='Sign up and download the app for access to FREE world-class training programs from top coaches in the TeamBuildr network.'
          title='Continue Your Training Journey'
          isIdnty
        >
          <Form
            id='registration'
            name='registration'
          >
            <GoogleAuthSection
              onGoogleConnect={setGoogleResponse}
            />
            <CommonFields
              errors={errors}
              setFieldValue={setFieldValue}
              showPasswordFields={!isRegisteringWithGoogle}
              touched={touched}
              values={values}
            />
            <AcceptAgreementField
              error={errors.acceptAgreement}
              setFieldValue={setFieldValue}
              touched={touched.acceptAgreement}
              values={{
                acceptAgreement: values.acceptAgreement,
              }}
            />
            <FormGroup>
              <Button
                bgColor='#00F5F5'
                disabled={!isValid || isSubmitting}
                fontSize='14px'
                fullWidth
                id='submit'
                large
                name='submit'
                noBorder
                onClick={handleSubmit}
                rounded
                txtColor='#000000'
                type='submit'
                upperCase
              />
            </FormGroup>
            <AlreadyHaveAccountText>
              {isMobile
                ? 'Already have an account? Open the app to sign in.'
                : 'Already have an account? Download the app on your mobile device to sign in.'}
            </AlreadyHaveAccountText>
            <AppDownloadButtons />
          </Form>
        </RegistrationFormWrapper>
      )}
    </Formik>
  );
};

export default IdntyRegistrationForm;
